import { render, staticRenderFns } from "./EmployeeInfo.vue?vue&type=template&id=512b4026&scoped=true"
import script from "./EmployeeInfo.vue?vue&type=script&lang=js"
export * from "./EmployeeInfo.vue?vue&type=script&lang=js"
import style0 from "./EmployeeInfo.vue?vue&type=style&index=0&id=512b4026&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512b4026",
  null
  
)

export default component.exports